import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { IntegrationReadyDeliveryStoreService } from '@/services/StoreManagement/IntegrationReadyDeliveryStore/IntegrationReadyDeliveryStoreService';

export type ListIntegrationReadyDeliveryStoreResponse = {
  external_store_id: string;
  delivery_service_id: number;
  external_store_name: string;
};

export const useListIntegrationReadyDeliveryStore = async (): Promise<
  ListIntegrationReadyDeliveryStoreResponse[]
> => {
  const integrationReadyDeliveryStoreService =
    new IntegrationReadyDeliveryStoreService(getClient());
  try {
    return await integrationReadyDeliveryStoreService.list();
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
